import * as React from 'react';
import {LocationRedirect} from "../components/LocationRedirect";
import routes from "../routes";

const R: React.FC = () => {
  return <LocationRedirect href={routes.cwmGlo}/>;
}
export default R;
